/* -----------------------------------------
Document setup
----------------------------------------- */

Watcher.observe('.js-default-casestudies', blocks => {
  // Loop the blocks array
  blocks.forEach(block => {
    // Get the slider container
    const container = block.querySelector('.js-default-casestudies__container');

    // Create an observer to add the in-view class to the slide when the slide is visible
    const Observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.target.classList.toggle('in-view', entry.isIntersecting);
      });
    }, {
      threshold: 1,
      rootMargin: '100% 0px 100% 0px'
    });

    // Create the slider
    block.tns = tns({
      container,
      items: 1,
      controls: true,
      nav: false,
      navPosition: 'bottom',
      mouseDrag: true,
      loop: true,
      mobileFirst: true,
      responsive: {
        768: {
          items: 2
        },
        1024: {
          items: 3
        }
      }
    });

    // Get the slider data
    const data = block.tns.getInfo();
    [...data.slideItems].forEach(slide => Observer.observe(slide));
    window.Lazy.update();
  });
});